export const countriesOptions = [
    { code: "PK", dial: "+92", maxLength: 10 }, // Pakistan
    { code: "US", dial: "+1", maxLength: 10 }, // USA
    { code: "CA", dial: "+1", maxLength: 10 }, // Canada
    { code: "GB", dial: "+44", maxLength: 10 }, // UK
    { code: "SA", dial: "+966", maxLength: 9 }, // Saudi Arabia
    { code: "AE", dial: "+971", maxLength: 9 }, // UAE
    { code: "QA", dial: "+974", maxLength: 8 }, // Qatar
    { code: "KW", dial: "+965", maxLength: 8 }, // Kuwait
    { code: "AU", dial: "+61", maxLength: 9 }, // Australia
    { code: "NZ", dial: "+64", maxLength: 9 }, // New Zealand
    { code: "CN", dial: "+86", maxLength: 11 }, // China
    { code: "DE", dial: "+49", maxLength: 11 }, // Germany
    { code: "TR", dial: "+90", maxLength: 10 }, // Turkey
    { code: "MY", dial: "+60", maxLength: 9 }, // Malaysia
];

export const categoryOptions = [
    { label: 'Chef', value: 'chef' },
    { label: 'Cook', value: 'cook' },
    { label: 'Helper', value: 'helper' },
    { label: 'Waiter', value: 'waiter' },
    { label: 'Driver', value: 'driver' },
    { label: 'Baby Sitter', value: 'baby_sitter' },
    { label: 'House Maid', value: 'house_maid' },
    { label: 'Patient Care', value: 'patient_care' },
    { label: 'Security Guard', value: 'security_guard' },
    { label: 'Office Boy', value: 'office_boy' },
    { label: 'Rider', value: 'rider' },
];

export const genderOptions = [
    { label: "Male", value: "male" },
    { label: "Female", value: "female" },
    { label: "Other", value: "other" }
];

export const relationOptions = [
    { label: "Father", value: "father" },
    { label: "Mother", value: "mother" },
    { label: "Husband", value: "husband" },
    { label: "Wife", value: "wife" },
    { label: "Brother", value: "brother" },
    { label: "Sister", value: "sister" },
    { label: "Son", value: "son" },
    { label: "Daughter", value: "daughter" },
    { label: "Uncle", value: "uncle" },
    { label: "Aunt", value: "aunt" },
    { label: "Cousin", value: "cousin" },
    { label: "Grandfather", value: "grandfather" },
    { label: "Grandmother", value: "grandmother" },
    { label: "Friend", value: "friend" },
    { label: "Neighbor", value: "neighbor" },
    { label: "Guardian", value: "guardian" },
    { label: "Other", value: "other" },
];

export const religionOptions = [
    { label: 'Muslim', value: 'muslim' },
    { label: 'Christian', value: 'christian' },
];

export const educationOptions = [
    { label: 'Illiterate', value: 'illiterate' },
    { label: 'Primary (1-5)', value: 'primary' },
    { label: 'Middle (6-8)', value: 'middle' },
    { label: 'Matric (9-10)', value: 'matric' },
    { label: 'Intermediate (11-12)', value: 'intermediate' },
    { label: 'Bachelor\'s', value: 'bachelor' },
    { label: 'Master\'s', value: 'master' },
];

export const jobTypeOptions = [
    { label: 'Full-Time', value: 'full_time' },
    { label: 'Part-Time', value: 'part_time' },
];

export const marriedStatusOptions = [
    { label: 'Married', value: 'married' },
    { label: 'Un-Married', value: 'unmarried' },
];

export const kidGenderOptions = [
    { label: 'Male', value: 'male' },
    { label: 'Female', value: 'female' },
    { label: 'Both', value: 'both' },
];

export const parentStatusOptions = [
    { label: 'Alive', value: 'alive' },
    { label: 'No More', value: 'no_more' },
];

export const employeeMediaRoles = [
    { label: "Profile", value: "profile" },
    { label: "Cnic Front", value: "cnic_front" },
    { label: "Cnic Back", value: "cnic_back" },
    { label: "Fingerprint", value: "fingerprint" },
    { label: "Signature", value: "signature" },
    { label: "B-Form", value: "bform" },
    { label: "Driving License Front", value: "driving_license_front" },
    { label: "Driving License Back", value: "driving_license_back" },
];

export const guarantorMediaRoles = [
    { label: "Cnic Front", value: "cnic_front" },
    { label: "Cnic Back", value: "cnic_back" },
    { label: "Fingerprint", value: "fingerprint" },
    { label: "Signature", value: "signature" },
];

export const entryTypeOptions = [
    { label: "New", value: "new" },
    { label: "Replace", value: "replace" },
];

export const entryStatusOptions = [
    { label: "Pending", value: "pending" },
    { label: "Approved", value: "approved" },
];

export const agreementValidOptions = [
    { label: "6 Months", value: "6_months" },
    { label: "5 Months", value: "5_months" },
    { label: "4 Months", value: "4_months" },
    { label: "3 Months", value: "3_months" },
    { label: "2 Months", value: "2_months" },
    { label: "1 Months", value: "1_months" },
];

export const agreementStatusOptions = [
    { label: "Pending", value: "pending" },
    { label: "Active", value: "active" },
    { label: "Expired", value: "expired" },
];

export const expenseTypeOptions = [
    { label: 'Bike Fuel', value: 'bike_fuel' },
    { label: 'Phone Recharge', value: 'phone_recharge' },
    { label: 'Phone Accessories', value: 'phone_accessories' },
    { label: 'Bike Maintenance', value: 'bike_maintenance' },
    { label: 'Eating Something', value: 'eating_something' },
    { label: 'Food for Someone', value: 'food_for_someone' },
    { label: 'Other', value: 'other' },
];

export const userRoleOptions = [
    { label: 'Admin', value: 'admin' },
    { label: 'Rider', value: 'rider' },
];

// For routing control
export const roleRouteMap = {
    admin: "/admin",
    rider: "/rider",
};